import { jsx as a } from "react/jsx-runtime";
import { useChatbotContext as e } from "../../hooks/useChatbotContext.js";
function n() {
  const { chatbot: r } = e();
  return (r == null ? void 0 : r.avatarUrl) != null ? /* @__PURE__ */ a(
    "img",
    {
      className: "aspect-square w-[30px] rounded-full",
      src: r.avatarUrl,
      alt: r == null ? void 0 : r.name
    }
  ) : null;
}
export {
  n as BotMessageAvatar
};
